import React from "react";
import { ProductItemCard as Component } from "./ProductItemCard";
export default React.memo(Component);
